module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_CN.e66b293c.txt";